import { render, staticRenderFns } from "./ChangeRequestComponent.vue?vue&type=template&id=a87720a4&scoped=true"
import script from "./ChangeRequestComponent.vue?vue&type=script&lang=js"
export * from "./ChangeRequestComponent.vue?vue&type=script&lang=js"
import style0 from "./ChangeRequestComponent.vue?vue&type=style&index=0&id=a87720a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87720a4",
  null
  
)

export default component.exports